/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Paste_Events_TitleInputs */



/**
* | output |
* | --- |
* | "Paste Events" |
*
* @param {Shortcut_Keys_Paste_Events_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_paste_events_title = /** @type {((inputs?: Shortcut_Keys_Paste_Events_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Paste_Events_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coller les evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incolla eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pegar eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを貼り付ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट इवेंट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Colar eventos")
	return /** @type {LocalizedString} */ ("Paste Events")
});